export const SET_HOVER_CCHV = 'SET_HOVER_CCHV'

export function setCchv(obj){
    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch( {
            type: SET_HOVER_CCHV,
            payload: obj
        })
    }
} 